import {
  CButton,
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CInputGroup,
  CInputGroupText,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
} from '@coreui/react-pro'
import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import {
  ResponseStatus,
  ResponseVip,
  mapResponseStatus,
  mapResponseVip,
  responseStatusArray,
  responseVipArray,
} from '../../../shared/enumeration/ResponseStatus'
import { IParams, ISelectValue } from '../../../shared/shared-interfaces'
import SModal from '../../shared/Modal/SModal'
import EyeIcon from '../../shared/icons/EyeIcon'
import EyeOffIcon from '../../shared/icons/EyeOffIcon'

import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import { INewUser, IUser } from '../../../shared/model/user.model'
import { AppDispatch } from '../../../store'
import { ToastSuccess } from '../../shared/toast/Toast'
import { createEntity, updateEntity } from './usersManagement.api'
import { fetching, resetEntity } from './usersManagement.reducer'
import { permissionSelectors } from '../SystemSetting/PermissionGroup/permission.reducer'
import { mapRoleToString, SystemRole, systemRoleArray } from '@/shared/enumeration/role'

interface IUserUpdateProps {
  visible: boolean
  setVisible: (visible: boolean) => void
  userObj?: IUser
}

const UserUpdate = (props: IUserUpdateProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const { initialState } = useSelector((state: RootState) => state.usersReducer)
  const { updateEntitySuccess } = initialState
  const { visible, setVisible, userObj } = props
  const handleOnClose = () => {
    setVisible(false)
  }

  const [passwordVisible, setPasswordVisible] = useState<boolean>(false)
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState<boolean>(
    false,
  )
  const permissionItems = useSelector(permissionSelectors.selectAll)

  const [permissionFilter, setPermissionFilter] = useState<IParams>({
    page: 1,
    limit: 20,
  })

  useEffect(() => {
    if (updateEntitySuccess) {
      setVisible(false)
      ToastSuccess(
        userObj ? 'Cập nhật tài khoản thành công' : 'Tạo tài khoản thành công',
      )
      dispatch(resetEntity())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEntitySuccess])



  const validationSchema = Yup.object().shape({
    username: Yup.string()
      .trim()
      .required('Không được để trống')
      .matches(/^\S+$/, 'Tên đăng nhập không được chứa khoảng trống')
      .matches(
        /^\w+$/,
        `Tên đăng nhập không được viết dấu hoặc chứa ký tự đặc biệt`,
      )
      .max(255, 'Số ký tự tối đa là 255 ký tự'),
    money: Yup.number().required('Không được để trống').nullable(),

    // fullName: Yup.string().trim().required('Không được để trống').nullable(),
    // email: Yup.string().trim().email('Email không đúng định dạng').required('Không được để trống'),
    // password: Yup.string().when('id', {
    //   is: (id: string) => true,
    //   then: Yup.string()
    //     .trim()
    //     .required('Không được để trống')
    //     .min(8, 'Mật khẩu phải có ít nhất 8 ký tự')
    //     .max(50, 'Mật khẩu tối đa 50 ký tự'),
    // }),
    // confirmPassword: Yup.string().when('id', {
    //   is: (id: string) => true,
    //   then: Yup.string()
    //     .trim()
    //     .required('Không được để trống')
    //     .min(8, 'Mật khẩu phải có ít nhất 8 ký tự')
    //     .max(50, 'Mật khẩu tối đa 50 ký tự')
    //     .test('passwords-match', 'Mật khẩu không khớp ', function (value) {
    //       return this.parent.password === value;
    //     }),
    // }),

    // password: Yup.string()
    //   .trim()
    //   .required('Không được để trống')
    //   .min(6, 'Mật khẩu phải có ít nhất 6 ký tự')
    //   .max(50, 'Mật khẩu tối đa 50 ký tự'),
    // confirmPassword: Yup.string()
    //   .trim()
    //   .required('Không được để trống')
    //   .min(6, 'Mật khẩu phải có ít nhất 6 ký tự')
    //   .max(50, 'Mật khẩu tối đa 50 ký tự')
    //   .test('passwords-match', 'Mật khẩu không khớp ', function (value) {
    //     return this.parent.password === value;
    //   }),
    status: Yup.string().trim().required('Không được để trống'),
    // permissionGroupId: Yup.string().required('Không được để trống'),
  })

  const returnOption = (
    optionValue: number | null | undefined,
    array: ISelectValue<string>[],
  ) => {
    if (!optionValue) return null
    if (!array.length) return null
    return array.find(({ value }) => Number(value) === optionValue)
  }

  return (
    <SModal
      visible={visible}
      onClose={handleOnClose}
      backdrop="static"
      className="custom-modal"
    >
  
    </SModal>
  )
}

export default UserUpdate
